// removed by extract-text-webpack-plugin
module.exports = {"Icon":"src-components-Icon----Icon-module---Icon---3TdpF","isLink":"src-components-Icon----Icon-module---isLink---e7Phv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.module.css
// module id = 14
// module chunks = 35783957827783 77196258398326 110308036455227 114276838955818 155911550660936 192279678295350